import React from "react";
import { Grid } from "@material-ui/core";
import MUIDataTable from "mui-datatables";

// import { PageTitle, Widget } from "../../../components/admin";

// import Chip from '@material-ui/core/Chip';
// import MuiTooltip from '@material-ui/core/Tooltip';
// import Fade from "@material-ui/core/Fade";
// import Checkbox from '@material-ui/core/Checkbox';
// import Radio from '@material-ui/core/Radio';
// import TableViewCol from './TableViewCol';

// import Table from "../dashboard/components/Table/Table";

import dataJson from "../../../data/A.json";
import PageTitle from "../../../components/admin/title";

// const CustomChip = (props) => {
// 	const { label, onDelete, columnNames, className, index } = props;
// 	return (<Chip
// 		className={className}
// 		variant="outlined"
// 		color={columnNames[index].name === 'Company' ? 'secondary' : 'primary'}
// 		label={label}
// 		onDelete={onDelete}
// 	/>);
//   };

//   const CustomTooltip = (props) => {
// 	return (
// 	  <MuiTooltip
// 		title={props.title}
// 		interactive={true}
// 		TransitionComponent={Fade}
// 		TransitionProps={{ timeout: 250 }}
// 		leaveDelay={250}>{props.children}</MuiTooltip>
// 	);
//   };

//   const CustomCheckbox = (props) => {
// 	let newProps = Object.assign({}, props);
// 	newProps.color = props['data-description'] === 'row-select' ? 'secondary' : 'primary';

// 	if (props['data-description'] === 'row-select') {
// 	  return (<Radio {...newProps} />);
// 	} else {
// 	  return (<Checkbox {...newProps} />);
// 	}
//   };


const datatableData = Object.keys(dataJson.pois).reduce((datas, item) => {
	const data = dataJson.pois[item];
	datas.push([
		data.lot,
		data.type,
		data.surface,
		data.price,
		data.floor,
		data.visible
	]);
	return datas;
}, []);


const Tables = props => {
	return (
		<>
			<PageTitle title="Lots list" />
			<MUIDataTable
				data={datatableData}
				columns={["lot", "type", "surface", "prix", "etage", "status"]}
				options={{
					filterType: "checkbox"
				}}
				// components={{
				// 	Tooltip: CustomTooltip,
				// 	Checkbox: CustomCheckbox,
				// 	TableViewCol: TableViewCol
				// 	}}
			/>
		</>
	);
}

export default Tables;
